import { useEffect, useState } from "react";
import { EnglishToPersian } from "numeral-convert";
import UserSectionMenu from "../../components/UserSectionMenu";
import AddRequestForm from "./AddRequestForm";
import UserInformation from "../../components/UserInformation";
import Pagination from "../../components/Pagination";
import { MyContext } from "../../context/myContext";
import HistoryPopUp from "../../components/HistoryPopUp";
import AddUserBox from "../../components/AddUserBox";
import EditRequestForm from "./EditRequestForm";
import { useDispatch, useSelector } from "react-redux";
import {
  callApiAgain,
  getNomadHistory,
  selectCallApi,
  selectNomadHistoryArray,
  selectShowEditForm,
  selectShowForm,
  selectShowHistory,
  showPopUp,
} from "../common-states/commonStatesSlice";
import {
  getRequests,
  selectRequestBodyArray,
  selectSelectedRequest,
  selectWaterType,
  setRequestInfo,
  setRequestStatus,
} from "./requestSlice";
import { handleShowPopUp } from "../common-states/handleShowPopUp";
import { getDriversByCity } from "../driver/driverSlice";
import { toGregorian } from "jalaali-js";

const RequestsManagement = () => {
  const [state, setState] = useState({
    selectedValue: { term: "", city: "" },
    input: "",
    emptyInputAlert: false,
    emptySelectAlert: false,
    isSearched: false,
  });

  const headArray = [
    "حذف",
    "سوابق",
    "زمان تحویل",
    "تاریخ تحویل",
    "زمان ثبت",
    "تاریخ ثبت",
    "کد پیگیری",
    "بررسی وضعیت",

    "منطقه عشایری",
    "شهرستان",
    "شماره تلفن",
    "نام متقاضی",
    "وضعیت",
    "ردیف",
  ];
  const requestHistoryTableHead = [
    "هزینه",
    "حجم آب",
    "زمان تحویل",
    "تاریخ تحویل",
    "راننده",
    "زمان درخواست",
    "منطقه",
    "کد پیگیری",
    "نوع آب",
    "ردیف",
  ];
  const initialState = {
    city_id: 1,
    population: "",
    code: "",
    name: "",
    waterVolume: "",
    driverId: "",
    insuredLiveStock: "",
    deliverTime: "",
    deliverDate: "",
    waterType: "",
    allocatedAt: "",
    allocatedByUser: "",
    cost: "",
    description: "",
    nomadReceiveDate: "",
  };
  const [editFormInputs, setEditFormInputs] = useState(initialState);
  const [nomad, setNomad] = useState({ id: null, name: "" });
  const dispatch = useDispatch();
  const historyArray = useSelector(selectNomadHistoryArray);
  const bodyArray = useSelector(selectRequestBodyArray);
  const waterType = useSelector(selectWaterType);
  const selectedRequest = useSelector(selectSelectedRequest);
  const showForm = useSelector(selectShowForm);
  const showEditForm = useSelector(selectShowEditForm);
  const showHistory = useSelector(selectShowHistory);
  const callApi = useSelector(selectCallApi);

  const handleShowForm = (item) => {
    console.log("items", item);
    dispatch(getDriversByCity(item?.city_id));

    dispatch(showPopUp({ type: "showEditForm", value: !showEditForm }));
    if (showEditForm === false) {
      //Below setting data when showing edit form
      let scheduled_to_deliver_at = item.scheduled_to_deliver_at
        ? new Date(item.scheduled_to_deliver_at).toLocaleDateString("fa-IR")
        : "";
      let driver_allocated_at_date = item.driver_allocated_at
        ? new Date(item.driver_allocated_at).toLocaleDateString("fa-IR") + " - "
        : "";
      let driver_allocated_at_time = item.driver_allocated_at
        ? EnglishToPersian(item.driver_allocated_at.slice(11))
        : "";
      let nomad_confirmed_at_date = item.nomad_confirmed_at
        ? new Date(item.nomad_confirmed_at).toLocaleDateString("fa-IR") + " - "
        : "";
      let nomad_confirmed_at_time = item.nomad_confirmed_at
        ? EnglishToPersian(item.nomad_confirmed_at.slice(11))
        : "";
      setEditFormInputs({
        city_id: item?.city_id,
        population: item.nomad.population,
        code: item.tanker_request_id,
        name: item.nomad?.name,
        waterVolume: item.water_volume,
        driverId: item.driver?.driver_id ?? "",
        insuredLiveStock: item.nomad.insured_livestock_count,
        deliverTime: item.scheduled_time ?? "",
        deliverDate: scheduled_to_deliver_at,
        waterType: item.water_type === 1 ? "آب شرب" : "آب دام",
        allocatedAt: driver_allocated_at_date + driver_allocated_at_time,
        allocatedByUser: item.driver_allocated_at_user_id?.name,
        cost: item.cost,
        description: item.description ?? "",
        nomadReceiveDate: nomad_confirmed_at_date + nomad_confirmed_at_time,
      });
      dispatch(setRequestStatus({ isRejected: item.is_rejected }));
    }
  };
  const handleShowHistory = (item) => {
    dispatch(showPopUp({ type: "showHistory", value: !showHistory }));
    setNomad({ ...nomad, name: item?.nomad?.name,id: item.nomad_id});
    if (showHistory === false) {
      dispatch(getNomadHistory({ nomad_id: item.nomad_id, page: 1 }));
    }
  };
  const handleClosePopup = () => {
    handleShowPopUp(dispatch, showForm, showEditForm, showHistory);
  };

  const handleChangePage = (item) => {
    dispatch(
      getRequests({
        searchParam:
          state.selectedValue.term +
          "=" +
          (state.selectedValue.term === "city_id"
            ? state.selectedValue.city
            : state.input),
        waterType,
        pageNum: item,
        dispatch,
      }),
    );
  };

  const handleSearch = (searchParam) => {
    console.log(state.input);
    dispatch(getRequests({ searchParam, waterType, pageNum: 1, dispatch }));
  };

  useEffect(() => {
    console.log(state.input);
    dispatch(
      getRequests({
        searchParam:
          state.selectedValue.term +
          "=" +
          (state.selectedValue.term === "city_id"
            ? state.selectedValue.city
            : state.input),
        waterType,
        pageNum: 1,
        dispatch,
      }),
    );
    dispatch(callApiAgain(false));
    return () => dispatch(setRequestStatus({ styles: [] }));
    // eslint-disable-next-line
  }, [callApi]);

  useEffect(() => {
    if (selectedRequest.obj !== null) {
      if (selectedRequest.type === "showEditForm") {
        handleShowForm(selectedRequest.obj);
      } else if (selectedRequest.type === "showHistory") {
        handleShowHistory(selectedRequest.obj);
      }
      dispatch(setRequestInfo({ obj: null, type: "" }));
    }
    // eslint-disable-next-line
  }, [selectedRequest]);
  const [persianDate, setPersianDate] = useState({
    startDate:'سال-روز-ماه' ,
    endDate: 'سال-روز-ماه',
  });
  const persianToEnglishNumber = (str) => {
    if (!str) return "";
    const persianNumbers = "۰۱۲۳۴۵۶۷۸۹";
    const englishNumbers = "0123456789";
    return str.replace(
      /[۰-۹]/g,
      (char) => englishNumbers[persianNumbers.indexOf(char)],
    );
  };
  const convertPersianToMiladi = (persianDateStr) => {
    const englishDigitDate = persianToEnglishNumber(persianDateStr);
    const parts = englishDigitDate.split(/[\/\-]/);
    if (parts.length !== 3) {
      throw new Error(
        "Invalid Persian date format. Use YYYY/MM/DD or YYYY-MM-DD",
      );
    }
    const jy = parseInt(parts[0], 10);
    const jm = parseInt(parts[1], 10);
    const jd = parseInt(parts[2], 10);
    const { gy, gm, gd } = toGregorian(jy, jm, jd);
    // Return as YYYY-MM-DD string (no time, no Z)
    return `${gy}/${String(gm).padStart(2, "0")}/${String(gd).padStart(2, "0")}`;
  };
  return (
    <div className="request-box bg-white rounded-md p-2 sm:p-6">
      <div
        className={`${(showHistory || showEditForm || showForm) && "visible bg-slate-700 opacity-50"} dark-background`}
        onClick={handleClosePopup}
      ></div>
      <MyContext.Provider
        value={{
          showHistory,
          handleShowHistory,
          headArray: requestHistoryTableHead,
          bodyArray: historyArray,
          title: `سوابق درخواست های ${nomad.name}`,
        }}
      >
        <HistoryPopUp
          persianDate={persianDate}
          setPersianDate={setPersianDate}
          excelData={{
            items: [
              { item: "row", col_name: "ردیف" },
              { item: "created_at", col_name: "تاریخ ثبت" },
              { item: "city_id", col_name: "شهر" },
              { item: "water_type", col_name: "نوع آب" },
              { item: "driver_id", col_name: "راننده" },
              { item: "nomad_id", col_name: "متقاضی" },
              { item: "settlement_status", col_name: "وضعیت تسویه" },
              { item: "driver_delivered_at", col_name: "زمان تایید راننده" },
              { item: "nomad_confirmed_at", col_name: "زمان تحویل عشایر" },
              { item: "description", col_name: "توضیحات" },
            ],
            sheet_type: 3,
            nomad_id: nomad?.id,
            start_created_at: convertPersianToMiladi(persianDate?.startDate),
            end_created_at: convertPersianToMiladi(persianDate?.endDate),
          }}
        />{" "}
      </MyContext.Provider>
      <MyContext.Provider
        value={{
          formTitle: "مشاهده و بررسی درخواست",
          showEditForm,
          handleShowForm,
          editFormInputs,
        }}
      >
        <AddUserBox formComponent={EditRequestForm} />
      </MyContext.Provider>
      <UserSectionMenu
        state={state}
        setState={setState}
        buttonText="افزودن درخواست"
        formTitle="افزودن درخواست جدید"
        formComponent={AddRequestForm}
        getSearchedInfo={handleSearch}
      />
      <MyContext.Provider
        value={{ headArray, bodyArray, title: "درخواست های ثبت شده" }}
      >
        <UserInformation />
      </MyContext.Provider>
      <Pagination handleChangePage={handleChangePage} />
    </div>
  );
};

export default RequestsManagement;
